/**
 * Note.js
 * Styled Component for the note images
 */
import styled from 'styled-components'

// Styles
const Note = styled.img`
    height: 60px;
    width: 60px;
`

export default Note;